<template>
  <div id="cjwt">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title">常见问题</div>
      </div>
    </header>
    <List :list="list" name="cjwt"></List>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import List from '@/components/list/List'
  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'cjwt',
    data () {
      return {
        list: []
      }
    },
    created: function () {
      ajax.getZzwdlist().then(
        data => {
          this.list = data
        }
      )
    },
    components: {
      OffCanvas,
      ICP,
      List
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// cjwt.vue?1729430e